<template>
  <i
    class="icon"
    :class="
      [
        `icon-${icon}`,
      ]"
  />
</template>

<script setup>
defineProps({
	icon: {
		type: String,
		required: true
	}
});
</script>

<style>
  /* .icon {
    position: relative;
  } */
</style>
